<template>
  <v-dialog
    v-model="active"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on }"/>
    </template>

    <v-card>
      <v-card-title
        class="title grey lighten-4"
        primary-title
      >
        Editar pasta
      </v-card-title>
      <v-card-text>
        <v-container
          class="fill-height"
        >
          <v-row
            class="ma-0 pt-4"
          >
            <v-text-field
              v-model="nmProject"
              label="Nome da pasta"
              prepend-icon="mdi-folder"
              :error-messages="nmProjectErrors"
              outlined
            >
            </v-text-field>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn
          color="accent"
          text
          @click="active = false"
        >
          Fechar
        </v-btn>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="onUpdateClick"
          :loading="isUpdating"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {validationMixin} from "vuelidate"
  import required from "vuelidate/src/validators/required"
  import maxLength from "vuelidate/src/validators/maxLength"
  import minLength from "vuelidate/src/validators/minLength"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../../helpers/notify"
  import {mapActions} from "vuex"
  import {UPDATE_PROJECT} from "../../../store/modules/project"

  export default {
    name: "ProjectEditDialog",
    mixins: [validationMixin],
    props: {
      project: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      active: false,
      isUpdating: false,
      nmProject: null,
    }),
    validations: {
      nmProject: {
        required,
        maxLength: maxLength(60),
        minLength: minLength(4),
      },
    },
    methods: {
      onUpdateClick() {
        this.$v.$touch()

        if (this.$v.$invalid) return

        this.isUpdating = true

        let projectData = {
          nm_project: this.nmProject,
        }
        this._updateProject({
            idProject: this.project["id_project"],
            projectData: projectData,
          })
          .then(() => {
            this.$notify(new NotificationOptions({
              message: "Projeto atualizado com sucesso!",
              type: NOTIFICATION_TYPES.SUCCESS,
            }))
          })
          .finally(() => {
            this.active = false
            this.isUpdating = false
          })
      },
      ...mapActions({
        _updateProject: UPDATE_PROJECT,
      }),
    },
    computed: {
      nmProjectErrors() {
        const errors = []
        if (!this.$v.nmProject.$dirty) return errors
        !this.$v.nmProject.required && errors.push("Esse campo é obrigatório")
        !this.$v.nmProject.minLength && errors.push("O nome do projeto precisa ter no minimo 4 caracteres")
        !this.$v.nmProject.maxLength && errors.push("O nome do projeto pode ter no máximo 60 caracteres")
        return errors
      },
    },
    watch: {
      active(newValue) {
        if (newValue) this.nmProject = this.project["nm_project"]
      },
    },
  }
</script>

<style scoped>

</style>
